const clauseNumberRegex = /^(\s*)((?:[0-9]+\.)+[A-Za-z]|([0-9]+\.)+[0-9]+|([A-Za-z]+\.)+[A-Za-z]+|[0-9]+\.|[A-Za-z]+\.|\([A-Za-z0-9]+\))([\s.]+)/;

export function stripClauseNumberPrefix(text: string): string {
  return text.replace(clauseNumberRegex, "");
}

export function hasClauseNumberPrefix(text: string): boolean {
  return clauseNumberRegex.test(text);
}

export function extractLastReferenceComponent(
  clauseReference: string | undefined,
): string | null {
  if (!clauseReference) {
    return null;
  }

  // Check for trailing parenthetical like (f) or (iii)
  const parenMatch = clauseReference.match(/\([^)]+\)$/);
  if (parenMatch) {
    return parenMatch[0];
  }

  // Otherwise return the full reference (e.g. "13.3" or "8")
  return clauseReference;
}

export function formatNumberPrefix(
  component: string,
  adjacentText: string,
): string {
  if (!adjacentText) {
    return `${component} `;
  }

  // Try to detect the separator used after the number in the adjacent text
  const separatorMatch = adjacentText.match(clauseNumberRegex);

  if (separatorMatch) {
    const adjacentNumber = separatorMatch[2];
    const separator = separatorMatch[5];

    if (adjacentNumber.endsWith(".") && !component.endsWith(".")) {
      return `${component}.${separator}`;
    }

    return `${component}${separator}`;
  }

  return `${component} `;
}
